import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import EmotionalSection from './components/EmotionalSection';
import CTASection from './components/CTASection';
import SEOHead from '../../components/SEO/SEOHead';
import StructuredData from '../../components/SEO/StructuredData';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
  
  const organizationData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AGRO-INNOVAZIONI S.r.l',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg',
    description: 'Spezie biologiche di alta qualità e biscotti biologici da tisana. Prodotti certificati biologici dalla terra alla tua tavola.',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Milano',
      addressRegion: 'MI',
      addressCountry: 'IT',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+39-0230310856',
      contactType: 'customer service',
      availableLanguage: 'Italian',
    },
    sameAs: [
      'https://www.instagram.com/agroinnovazioni',
      'https://www.facebook.com/agroinnovazioni',
    ],
  };

  const webPageData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'AGRO-INNOVAZIONI - Spezie e Biscotti Biologici di Alta Qualità',
    description: 'Scopri le nostre spezie biologiche certificate e biscotti artigianali da tisana. Qualità italiana dalla terra alla tua tavola.',
    url: `${siteUrl}/`,
    mainEntity: organizationData,
  };

  return (
    <>
      <SEOHead
        title="AGRO-INNOVAZIONI Milano Sassuolo - Spezie Biologiche e Biscotti da Tisana"
        description="AGRO-INNOVAZIONI S.r.l - Spezie biologiche di alta qualità e biscotti biologici da tisana. Prodotti certificati biologici dalla terra alla tua tavola. Sede a Milano e Sassuolo."
        keywords="spezie biologiche, biscotti biologici, tisana, prodotti bio, Milano, Sassuolo, AGRO-INNOVAZIONI"
        ogTitle="AGRO-INNOVAZIONI - Spezie e Biscotti Biologici di Alta Qualità"
        ogDescription="Scopri le nostre spezie biologiche certificate e biscotti artigianali da tisana. Qualità italiana dalla terra alla tua tavola."
        ogImage="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
        ogType="website"
        canonical={`${siteUrl}/`}
      />
      <StructuredData type="WebPage" data={webPageData} />
      <StructuredData type="Organization" data={organizationData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedProducts />
          <EmotionalSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
